module.exports = __webpack_public_path__ + "img/navbar-brand.ccfe44d8.png";